import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
import { Container } from '../../comps/Container'
import React, { useState, useEffect } from 'react'
import { InactivityDialog } from '../../comps/InactivityDialog'
import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
import { ServiceHighlights } from '../../comps/ServiceHighlight'
import { IconWithText } from '../../comps/IconWithText'
import { AepsCheckBox } from '../../comps/AepsCheckBox'
import { AepsButton } from '../../comps/AepsButton'
import { flex } from 'styled-system'
import { RowItem } from '../../comps/RowItem'
import { useNavigation } from '@react-navigation/native'
import { useRoute } from '@react-navigation/core'
import { Screens } from '../../nav/Screens'

// Mock data and functions to simulate a dynamic component
const useLazyApiData = (apiFn) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)


    const callApi = async () => {
        setLoading(true)
        setError(null)
        try {
            // Simulate an API call with a delay
            const mockData = await new Promise(resolve => setTimeout(() => {
                // Mock data based on the section
                if (apiFn.name === 'fetchFavourites') {
                    resolve([
                        { id: '1', name: 'ICICI Bank FASTag', customerName: 'Prakash', vehicleNo: 'MH034589', lastLinked: 'O5 june 2025' },
                        { id: '2', name: 'Airtel Postpaid', customerName: 'Rahul', mobileNo: '9876543210', lastLinked: '10 July 2025' }
                    ])
                } else if (apiFn.name === 'fetchRecentPayments') {
                    resolve([
                        { id: '3', name: 'BSES Rajdhani', customerName: 'Anil', accountNo: '12345678', lastLinked: '22 May 2025' },
                        { id: '4', name: 'JioFiber', customerName: 'Priya', accountNo: '87654321', lastLinked: '01 June 2025' }
                    ])
                } else {
                    resolve([])
                }
            }, 1000))
            setData(mockData)
        } catch (err) {
            setError(err)
        } finally {
            setLoading(false)
        }
    }

    return [data, callApi, loading, error]
}

const mockFetchFavourites = () => { /* This function is just a placeholder to be used by the hook */ }
const mockFetchRecentPayments = () => { /* This function is just a placeholder to be used by the hook */ }

const staticData = [
    {
        initials: "RJ",
        name: "Riya Jain",
        phoneNumber: "9876543210"
    },
    {
        initials: "RJ",
        name: "Riya Jain",
        phoneNumber: "9876543210"
    },
    {
        initials: "RJ",
        name: "Riya Jain",
        phoneNumber: "9876543210"
    },
    {
        initials: "RJ",
        name: "Riya Jain",
        phoneNumber: "9876543210"
    },
    {
        initials: "RJ",
        name: "Riya Jain",
        phoneNumber: "9876543210"
    },
    {
        initials: "RJ",
        name: "Riya Jain",
        phoneNumber: "9876543210"
    },
    {
        initials: "RJ",
        name: "Riya Jain",
        phoneNumber: "9876543210"
    },
]

export const AgentTransactionHistory = () => {
    const [favourites, fetchFavourites, favouritesLoading] = useLazyApiData(mockFetchFavourites)
    const [recentPayments, fetchRecentPayments, paymentsLoading] = useLazyApiData(mockFetchRecentPayments)
    const [activeTab, setActiveTab] = useState('payBills')
    const [showInactivityDialog, setShowInactivityDialog] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [checked, setChecked] = useState(false)
    const routes = useRoute()
    const handleInactivityDialogPress = () => {
        setShowInactivityDialog(false);
    };

    useEffect(() => {
        fetchFavourites()
        fetchRecentPayments()
    }, [])

    const searchList = (tnxId) => {
        console.log(tnxId)
    }

    const handlePress = () => {
        setShowInactivityDialog(true)
        console.log("enter something here.")
    }

    const onPrimaryButtonPress = () => {
        setOpenConfirmDialog(true)
    }

    return (
        <Container showFooter={true} overflow='auto'>
            <>
                <Box marginBottom={14}>
                    <TextNew fontSize={24} color="BLACK" fontWeight={'600'}>
                        Recent Payments
                    </TextNew>
                </Box>
                <Box backgroundColor="WHITE">
                    <Box padding={15} marginTop={15} marginBottom={15} backgroundColor="#F8EBD7" borderRadius={15}>
                        <Box flexDirection={'row'} justify={'space-between'}>
                            <Box>
                                <TextNew fontSize={15} color="BLACK">
                                    ICICI Bank FASTag
                                </TextNew>
                                <TextNew fontSize={14} color="DARK_GREY_2" fontWeight={'400'}>
                                    Prakash
                                </TextNew>
                                <TextNew fontSize={14} color="BLACK">
                                    MH034589
                                </TextNew>
                            </Box>

                            <Box marginTop={15} flexDirection={'row'}>
                                <Spacer direction="horizontal" size={16} />
                                <Icon id={'FAVOURITE_FILLED'} color="AVAILABLE_GREEN" size={16} />
                                <Icon id={'MENU'} color="AVAILABLE_GREEN" size={16} />
                            </Box>
                        </Box>
                        <Box borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginTop={12} marginBottom={12} borderStyle={'dashed'} />
                        <Box marginTop={15} flexDirection={'row'} justify={'space-between'}>
                            <TextNew fontSize={14} color='DARK_GREY_2' fontWeight={'400'}>
                                Last Link on O5 june 2025
                            </TextNew>
                            <ButtonNew
                                type={'secondarySmall'}
                                title={'Pay'}
                                color={'WHITE'}
                                underlayColor={'BRAND_PRIMARY_WHITE'}
                                borderColor={'PRIMARY'}
                                titleColor={'PRIMARY'}
                            />
                        </Box>
                    </Box>
                </Box>
                <Box backgroundColor="WHITE">
                    <Box padding={15} marginTop={15} marginBottom={15} backgroundColor="#F8EBD7" borderRadius={15}>
                        <Box flexDirection={'row'} justify={'space-between'}>
                            <Box>
                                <TextNew fontSize={15} color="BLACK">
                                    ICICI Bank FASTag
                                </TextNew>
                                <TextNew fontSize={14} color="DARK_GREY_2" fontWeight={'400'}>
                                    Prakash
                                </TextNew>
                                <TextNew fontSize={14} color="BLACK">
                                    MH034589
                                </TextNew>
                            </Box>

                            <Box marginTop={15} flexDirection={'row'}>
                                <Spacer direction="horizontal" size={16} />
                                <Icon id={'FAVOURITE_FILLED'} color="AVAILABLE_GREEN" size={16} />
                                <Icon id={'MENU'} color="AVAILABLE_GREEN" size={16} />
                            </Box>
                        </Box>
                        <Box borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginTop={12} marginBottom={12} borderStyle={'dashed'} />
                        <Box marginTop={15} flexDirection={'row'} justify={'space-between'}>
                            <TextNew fontSize={14} color='DARK_GREY_2' fontWeight={'400'}>
                                Last Link on O5 june 2025
                            </TextNew>
                            <ButtonNew
                                type={'secondarySmall'}
                                title={'Pay'}
                                color={'WHITE'}
                                underlayColor={'BRAND_PRIMARY_WHITE'}
                                borderColor={'PRIMARY'}
                                titleColor={'PRIMARY'}
                            />
                        </Box>
                    </Box>
                </Box>
                <Box backgroundColor="WHITE">
                    <Box padding={15} marginTop={15} marginBottom={15} backgroundColor="#F8EBD7" borderRadius={15}>
                        <Box flexDirection={'row'} justify={'space-between'}>
                            <Box>
                                <TextNew fontSize={15} color="BLACK">
                                    ICICI Bank FASTag
                                </TextNew>
                                <TextNew fontSize={14} color="DARK_GREY_2" fontWeight={'400'}>
                                    Prakash
                                </TextNew>
                                <TextNew fontSize={14} color="BLACK">
                                    MH034589
                                </TextNew>
                            </Box>

                            <Box marginTop={15} flexDirection={'row'}>
                                <Spacer direction="horizontal" size={16} />
                                <Icon id={'FAVOURITE_FILLED'} color="AVAILABLE_GREEN" size={16} />
                                <Icon id={'MENU'} color="AVAILABLE_GREEN" size={16} />
                            </Box>
                        </Box>
                        <Box borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginTop={12} marginBottom={12} borderStyle={'dashed'} />
                        <Box marginTop={15} flexDirection={'row'} justify={'space-between'}>
                            <TextNew fontSize={14} color='DARK_GREY_2' fontWeight={'400'}>
                                Last Link on O5 june 2025
                            </TextNew>
                            <ButtonNew
                                type={'secondarySmall'}
                                title={'Pay'}
                                color={'WHITE'}
                                underlayColor={'BRAND_PRIMARY_WHITE'}
                                borderColor={'PRIMARY'}
                                titleColor={'PRIMARY'}
                            />
                        </Box>
                    </Box>
                </Box>
                <Box backgroundColor="WHITE">
                    <Box padding={15} marginTop={15} marginBottom={15} backgroundColor="#F8EBD7" borderRadius={15}>
                        <Box flexDirection={'row'} justify={'space-between'}>
                            <Box>
                                <TextNew fontSize={15} color="BLACK">
                                    ICICI Bank FASTag
                                </TextNew>
                                <TextNew fontSize={14} color="DARK_GREY_2" fontWeight={'400'}>
                                    Prakash
                                </TextNew>
                                <TextNew fontSize={14} color="BLACK">
                                    MH034589
                                </TextNew>
                            </Box>

                            <Box marginTop={15} flexDirection={'row'}>
                                <Spacer direction="horizontal" size={16} />
                                <Icon svgId='mobile_recharge_icon' id={'FAVOURITE_FILLED'} color="AVAILABLE_GREEN" size={16} />
                                <Icon id={'MENU'} color="AVAILABLE_GREEN" size={16} />
                            </Box>
                        </Box>
                        <Box borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginTop={12} marginBottom={12} borderStyle={'dashed'} />
                        <Box marginTop={15} flexDirection={'row'} justify={'space-between'}>
                            <TextNew fontSize={14} color='DARK_GREY_2' fontWeight={'400'}>
                                Last Link on O5 june 2025
                            </TextNew>
                            <ButtonNew
                                type={'secondarySmall'}
                                title={'Pay'}
                                color={'WHITE'}
                                underlayColor={'BRAND_PRIMARY_WHITE'}
                                borderColor={'PRIMARY'}
                                titleColor={'PRIMARY'}
                            />
                        </Box>
                    </Box>
                </Box>
                <Box backgroundColor="WHITE">
                    <Box padding={15} marginTop={15} marginBottom={15} backgroundColor="#F8EBD7" borderRadius={15}>
                        <Box flexDirection={'row'} justify={'space-between'}>
                            <Box>
                                <TextNew fontSize={15} color="BLACK">
                                    ICICI Bank FASTag
                                </TextNew>
                                <TextNew fontSize={14} color="DARK_GREY_2" fontWeight={'400'}>
                                    Prakash
                                </TextNew>
                                <TextNew fontSize={14} color="BLACK">
                                    MH034589
                                </TextNew>
                            </Box>

                            <Box marginTop={15} flexDirection={'row'}>
                                <Spacer direction="horizontal" size={16} />
                                <Icon id={'FAVOURITE_FILLED'} color="AVAILABLE_GREEN" size={16} />
                                <Icon id={'MENU'} color="AVAILABLE_GREEN" size={16} />
                            </Box>
                        </Box>
                        <Box marginTop={15} flexDirection={'row'} justify={'space-between'}>
                            <TextNew fontSize={14} color='DARK_GREY_2' fontWeight={'400'}>
                                Last Link on O5 june 2025
                            </TextNew>
                            <ButtonNew
                                type={'secondarySmall'}
                                title={'Pay'}
                                color={'WHITE'}
                                underlayColor={'BRAND_PRIMARY_WHITE'}
                                borderColor={'PRIMARY'}
                                titleColor={'PRIMARY'}
                            />
                        </Box>
                    </Box>
                </Box>

            </>
        </Container>
    )
}